import React, { useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./styles.scss";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    }}
    className="options-toggle"
  >
    {children}
  </div>
));

const iconTextStyles = {
  textDecoration: "none",
  color: "#4E5566",
  fontFamily: "Plus Jakarta Sans",
  fontSize: "14px",
  fontWeight: "400",
  textAlign: "left",
  lineHeight: "22px",
};

const OptionsMenu = ({
  optionsList,
  passedData,
  secondParam,
  row = {},
  dropdownStyles = {},
}) => {
  const toggleRef = useRef(null);
  if (optionsList?.length === 0) return null;
  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%' }}>
      <Dropdown style={dropdownStyles}>
        <Dropdown.Toggle
          id="dropdown-basic"
          as={CustomToggle}
          ref={toggleRef}
          className="transparent-dropdown-toggle"
        >
          <img
            src="/Three-dots.svg"
            alt="three-dots"
            style={{ cursor: "pointer" }}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu
          align="start"
          flip
          renderOnMount
          popperConfig={{
            modifiers: [
              {
                name: 'preventOverflow',
                options: {
                  padding: 8,
                },
              },
              {
                name: 'offset',
                options: {
                  offset: [0, 4],
                },
              },
            ],
          }}
          style={{
            padding: "12px 0px 12px 0px",
          }}
        >
        {optionsList.map((option) => (
          <Dropdown.Item
            key={typeof option.text === "function" 
              ? option.text(row) 
              : option.text}
            onClick={(e) => {
              e.stopPropagation();
              option.actionsHandler(passedData, secondParam);
            }}
            style={{ padding: "0px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 18px 5px 18px",
              }}
            >
              <span style={iconTextStyles}>
                {typeof option.text === "function"
                  ? option.text(row)
                  : option.text}
              </span>
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
    </div>
  );
};

export default OptionsMenu;
